import { BiHelpCircle } from 'react-icons/bi';
import InputGroup from 'react-bootstrap/InputGroup';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

function Help({topic}) {
    if (topic === "email") {
        return (
          <>
            this is your account "identity" on allthebots
            <ul>
              <li>verified by sending a code on account creation and password reset</li>
              <li>never shared or sold!</li>
              <li>in future: opt-in to get emailed about bot activity</li>
              <li>in future: opt-in to get emailed about allthebots changes</li>
            </ul>
          </>
        );
    }
    if (topic === "namespace") {
        return (
          <>
            globally unique, short account identifier
            <ul>
              <li>must be a valid RFC1123 subdomain: lower-case latin-1 letters, digits, and '-'</li>
              <li>1-32 characters long</li>
            </ul>
          </>
        );
    }
    if (topic === "nonce") {
        return (
          <>
            6 character code sent to your email. each nonce can only be used once, and expires after a few minutes!
          </>
        )
    }
    if (topic === "password") {
        return (
          <>
            keep it secret. keep it safe!
          </>
        )
    }
    if (topic === "handle") {
        return (
          <>
            uniquely identifies a bot within a namespace
            <ul>
              <li>must be a valid RFC1123 subdomain: lower-case latin-1 letters, digits, and '-'</li>
              <li>1-32 characters long</li>
              <li>it is changeable, but currently this requires contacting support</li>
            </ul>
          </>
        );
    }
    if (topic === "secret name") {
        return (
          <>
            uniquely (case-insensitively!) identifies a secret within a bot
            <ul>
              <li>must consist of latin-1 letters, digits, and the characters '-', '_' and '.'</li>
              <li>1-32 characters long</li>
              <li>in future: opt-in for "tight integration" features based on the kind of secret, e.g. using a discord client secret to integrate with the discord API</li>
            </ul>
          </>
        );
    }
    if (topic === "secret value") {
        return (
          <>
            the actual secret. shhhhh!
            <ul>
              <li>always encrypted in our database</li>
              <li>always redacted when accessed via the app (or api)</li>
              <li>made available to your running bot via a file in <code>/secrets</code></li>
            </ul>
          </>
        );
    }
    if (topic === "discord client secret") {
        return (
          <>
            the "CLIENT SECRET" copied from your application on the discord developer portal
          </>
        );
    }
}

export function HelpoverInputGroup({topic, ...rest}) {
    return (
        <InputGroup.Append>
          <OverlayTrigger trigger="click" placement="bottom" overlay={
              <Popover>
                <Popover.Title><div className="small">{topic}</div></Popover.Title>
                <Popover.Content><div className="small"><Help topic={topic}/></div></Popover.Content>
              </Popover>
          }>
            <InputGroup.Text><BiHelpCircle/></InputGroup.Text>
          </OverlayTrigger>
        </InputGroup.Append>
    );
}

export function HelpoverText({topic, children, ...rest}) {
    return (
        <OverlayTrigger trigger="click" placement="bottom" overlay={
            <Popover>
              <Popover.Title><div className="small">{topic}</div></Popover.Title>
              <Popover.Content><div className="small"><Help topic={topic}/></div></Popover.Content>
            </Popover>
        }>
          <div>
            {children}<sup><BiHelpCircle/></sup>
          </div>
        </OverlayTrigger>
    )
}
